import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getEntityTypeSegmentTabDetails } from './selectors';

export const useEntityTypeScheduleEnabled = (dataType, publicConfig = false) => {
  const { segment_fields: segmentFields = [] } = useSelector(
    state => getEntityTypeSegmentTabDetails(state, dataType, publicConfig)
  );
  return useMemo(() => {
    const includedSegmentFields = new Set(segmentFields);
    return includedSegmentFields.has('schedule');
  }, [segmentFields]);
};
